import { Component, input } from '@angular/core';
import { TimeTrack } from 'src/app/entities/time-track/time-track';
import { TrackListComponent } from '../track-list/track-list.component';
import { Project } from 'src/app/entities/project/project';
import { Tag } from 'src/app/entities/tag/tag';
import { DateService } from 'src/app/services/date-service/date.service';
import { FiltersService } from 'src/app/services/filters-service/filters.service';
import { User } from 'src/app/entities/user/user';
import { CustomDateFilterComponent, DateFiltersValues } from '../../atoms/custom-date-filter/custom-date-filter.component';

@Component({
  selector: 'app-reports-detailed',
  imports: [TrackListComponent, CustomDateFilterComponent],
  templateUrl: './reports-detailed.component.html',
  styleUrl: './reports-detailed.component.scss'
})
export class ReportsDetailedComponent {

  timeTracks = input<TimeTrack[]>([]);

  projects = input<Project[]>([]);

  tags = input<Tag[]>([]);

  users = input<User[]>([]);

  periodStart = new Date();

  periodEnd = new Date();


  constructor(
    protected dateService: DateService,
    protected filters: FiltersService
  ) { }

  get totalHours() {
    let totalSeconds = 0

    this.timeTracks().forEach(track => { totalSeconds += track.time_spent || 0 })

    // Convert seconds to hours and minutes
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${hours}h ${minutes}m`;
  }

  protected setDateFilterPeriods(event: DateFiltersValues) {
    this.periodStart = new Date(event.startDate);
    this.periodEnd = new Date(event.endDate);

    this.setTracksFilterDates(
      this.dateService.getLocalIsosString(this.periodStart),
      this.dateService.getLocalIsosString(this.periodEnd)
    );
  }

  protected setTracksFilterDates(start: string, end: string): void {
    this.filters.setTimeTracksFilters({
      from: start,
      to: end
    });
  }
}
